import { warn } from '@execonline-inc/logging';
import { pipe } from '@kofno/piper';
import { fromNullable } from 'maybeasy';
import { Task } from 'taskarian';
import { errorMessage } from '../../ExceptionHandling';
import { JWPlayerFn, jwPlayerLoadError, JWPlayerLoadError } from '../../JWPlayer/Types';

declare global {
  interface Window {
    jwplayer?: JWPlayerFn;
  }
}

export const loadJWPlayer = (url: string, key: string): Task<JWPlayerLoadError, JWPlayerFn> => {
  return new Task<JWPlayerLoadError, JWPlayerFn>((reject, resolve) => {
    const rejectException = pipe(errorMessage, jwPlayerLoadError, reject);
    try {
      fromNullable(window.jwplayer)
        .map((jwplayer) => resolve(jwplayer))
        .getOrElse(() => {
          const script = document.createElement('script');
          script.src = url;
          script.type = 'text/javascript';
          script.onload = () => {
            fromNullable(window.jwplayer)
              .map((jwplayer) => {
                jwplayer.key = key;
                resolve(jwplayer);
              })
              .getOrElse(() => reject(jwPlayerLoadError('`window.jwplayer` not loaded by script')));
          };
          fromNullable(document.head).do(() => document.head.appendChild(script));
        });
    } catch (e) {
      rejectException(e);
    }

    return () => {
      warn('Loading the JWPlayer API cannot be canceled');
    };
  });
};
